export const platformsData = [{
        name: "LeetCode",
        link: "https://leetcode.com/anshika_5501/",
        avatar: "./images/platforms/leetcode.png",
    },
    {
        name: "GeeksforGeeks",
        link: "https://auth.geeksforgeeks.org/user/anshikaagrawal5501/profile",
        avatar: "./images/platforms/gfg.png",
    },
    {
        name: "HackerRank",
        link: "https://www.hackerrank.com/Anshika_Agrawal?hr_r=1",
        avatar: "./images/platforms/hackerrank.png",
    },
    {
        name: "HackerEarth",
        link: "https://www.hackerearth.com/@Anshika_Agrawal",
        avatar: "./images/platforms/hackerearth.png",
    },
    {
        name: "CodeChef",
        link: "https://www.codechef.com/users/anshika_ag",
        avatar: "./images/platforms/codechef.png",
    }
];